export type WakeLockProvider = { request(type: 'screen'): Promise<WakeLockSentinel> };

export async function requestScreenWakeLock(provider: WakeLockProvider | undefined, visible: boolean): Promise<WakeLockSentinel | undefined> {
  if (!provider || !visible) return undefined;
  return provider.request('screen');
}
